






import { Vue, Prop, Watch, Component } from 'vue-property-decorator'
import { campusList } from '@/api/config'

@Component({
  name: 'ClassChange'
})
export default class extends Vue {
  @Prop({ required: true }) private bindId!:{}
  @Prop({ default: false }) private multiple!:boolean
  @Prop({ default: 'small' }) private size!:string

  private id:[] = []
  private props:any = {
    value: 'classroomId',
    label: 'name',
    children: 'classroomVoList'
  }
  private options:[] = []

  @Watch('id', { immediate: true, deep: true })
  onChangeValue(newVal:[]) {
    if (newVal.length > 1) {
      this.$emit('update:bindId', {
        campusId: (newVal as any)[0],
        classroomId: (newVal as any)[1]
      })
    } else if (newVal.length > 0) {
      this.$emit('update:bindId', {
        campusId: '',
        classroomId: (newVal as any)[0]
      })
    } else {
      this.$emit('update:bindId', {
        campusId: '',
        classroomId: ''
      })
    }
  }

  created() {
    campusList({}).then(res => {
      if (this.$store.state.user.campus.origin === 1) {
        // 总部
        this.options = res.data.array || []
      } else {
        // 校区
        this.options = (res.data.array || []).length ? res.data.array[0].classroomVoList : []
      }
    }).catch(() => {})
  }

  /**
   * 选择所有班级
   */
  private chooseAll() {
    this.id = []
    this.$nextTick(() => {
      this.$emit('change')
    })
  }
  /**
   * 切换班级
   */
  private handleChange() {
    this.$nextTick(() => {
      this.$emit('change')
    })
  }
}
